import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

export default function FixcenterFooterSkeleton() {
    const count = 10;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: 600,
                width: '100%',
                margin: '0 auto',
                padding: 0,
            }}
        >
            {[...Array(count)].map((_, index) => (
                <Skeleton key={index} variant="rectangular" width="100%" height={30} animation="wave" />
            ))}
        </Box>
    );
}
